import React from 'react';

import {getLanguageEntry } from "../../utils/Helper";
import ReportModal from "../../components/modals/ReportModal";
import {ReportReason} from "../../utils/Types.ts";

class LegalNoticeContentPage extends React.Component {
    constructor(props) {
        super(props);
        this.report_modal = React.createRef();
    }

    render() {
        return (
            <div id="content-legal-notice" className="content-page">
                <div className="container">
                    <h1 className="content-title">{getLanguageEntry("content_pages>legalnotice>title")}</h1>
                    <div>
                        <div className='content-page-block'>
                            <p>
                                <strong>roomjack GmbH</strong><br/>
                                ℅ Steamwork<br/>
                                Roonstr. 23 A<br/>
                                76137 Karlsruhe<br/>
                                Deutschland
                            </p>
                            <p>
                                Fon: +49 721 981915-10<br/>
                                Mail: hello@roomjack.de 
                            </p>
                            <p>
                                Geschäftsführer: Christoph Schiestl, Philipp Schiestl<br/>
                                Registergericht: Amtsgericht Mannheim<br/>
                                Registernummer: HRB 754531<br/>
                                Ust-IdNr.: DE454941561
                            </p>
                        </div>
                    </div>
                </div>
                <ReportModal ref={this.report_modal} userData={this.props.userData}/>
            </div>
        )
    }
    callReportModal() {
        this.report_modal.current.show(null, ReportReason.contact);
    }
}
export default LegalNoticeContentPage;
